import { RxPlus } from "react-icons/rx";

import { Input } from "@sorcery/ui";

export const CollectionQuantitySelector = ({
  quantity,
  onChange,
  error,
}: {
  quantity: number;
  onChange: (quantity: number) => void;
  error?: boolean;
}) => {
  return (
    <div className="">
      <Input
        type="number"
        min={1}
        error={error}
        className={"max-w-[6rem]"}
        value={quantity.toString()}
        onChange={(v) => {
          onChange(Number.parseInt(v) ?? 0);
        }}
        size={"md"}
        RightComponent={
          <div className="flex h-full w-full flex-row items-center justify-end pr-1">
            <div
              onClick={() => {
                onChange(quantity + 1);
              }}
              className={
                "hover:border-primary flex h-[25px] w-[25px] cursor-pointer select-none flex-col items-center justify-center rounded-full p-1 transition-shadow hover:border hover:shadow-[0_0_18px_rgba(255,123,0,0.9)]"
              }
            >
              <RxPlus size={25} />
            </div>
          </div>
        }
      />
    </div>
  );
};
